import { useState, useCallback } from "react";
import { apiService } from "@/core/api";
import { API_ENDPOINTS } from "@/core/constants/endpoints";
import { fetchUserBasicInfoRequested } from "@features/user/store";

export const TeamManagementViewModel = (
  refetchOrganization: () => Promise<void>
) => {
  const [actionLoading, setActionLoading] = useState<string | null>(null);

  const makeAdmin = useCallback(
    async (memberId: string) => {
      setActionLoading(memberId);
      try {
        await apiService.post(API_ENDPOINTS.PARTNERS.CHANGE_ADMIN, {
          target_uid: memberId,
        });
        await refetchOrganization();
        fetchUserBasicInfoRequested();
        return true;
      } catch (error) {
        console.error("Failed to make member admin:", error);
        throw error;
      } finally {
        setActionLoading(null);
      }
    },
    [refetchOrganization]
  );

  const removeMember = useCallback(
    async (memberId: string) => {
      setActionLoading(memberId);
      try {
        await apiService.post(API_ENDPOINTS.PARTNERS.REMOVE_MEMBER, {
          target_uid: memberId,
        });
        await refetchOrganization();
        return true;
      } catch (error) {
        console.error("Failed to remove member:", error);
        throw error;
      } finally {
        setActionLoading(null);
      }
    },
    [refetchOrganization]
  );

  const sendInvitations = useCallback(async (emails: string[]) => {
    setActionLoading("invitations");
    try {
      const response = await apiService.post(API_ENDPOINTS.PARTNERS.SEND_INVITATIONS, {
        emails,
      });
      return response;
    } catch (error) {
      console.error("Failed to send invitations:", error);
      throw error;
    } finally {
      setActionLoading(null);
    }
  }, []);

  return {
    makeAdmin,
    removeMember,
    sendInvitations,
    actionLoading,
  };
};
